<template>
  <v-container
    id="usersSelectDialog"
  >
    <v-card>
      <v-card-title>
        {{ $t('userselection.add-learners') }}
</v-card-title>
      <v-card-text>
      <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('global.search')"
          single-line
          hide-details
        />
      </v-card-text>
      <v-data-table
        v-model="selection"
        :headers="headers"
        :items="items"
        item-key="id"
        :loading="loading"
        :search="search"
        :sort-by="['displayName']"
        :sort-desc="[false]"
        show-select
      >
        <template v-slot:item.displayName="{ item }">
          {{ item.displayName }}
        </template>
        <template v-slot:item.tag="{ item }">
          {{ item.tag }}
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" @click="cancel">
{{ $t('global.cancel') }}
</v-btn>
        <v-btn :disabled="!selection.length>0" color="success" @click="validate">
{{ $t('global.continue') }}
</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>

  // import api from '@/helpers/api.js'
  // import { Users } from '@/helpers/users.js'

  export default {
    name: 'UserSelectDialog',

    props: {
      items: {
        type: Array,
        required: true,
        default: undefined,
      },
    },

    data () {
      return {
        loading: false,
        search: '',
        selection: [],
        headers: [
          { text: this.$t('userselection.name'), value: 'displayName', sortMethod: (a, b) => a.toLowerCase().localeCompare(b.toLowerCase()) },
          { text: this.$t('userselection.tag'), sortable: true, value: 'tag' },
        ],
      }
    },

    mounted () {
      this.reset()
    },

    methods: {
      reset () {
        this.selection = []
      },
      async validate () {
        this.$emit('save', this.selection)
      },
      cancel () {
        this.$emit('cancel')
        console.log({ items: this.items })
      },
    },
  }
</script>

<style scoped>
.marginLeft {
  margin-left: 8px;
}
</style>
